import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Navbar onBookDemo={() => {}} />
      <div className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" style={{ fontFamily: '"Playfair Display", Georgia, serif' }}>
              Terms of <span className="text-gradient">Service</span>
            </h1>
            <p className="text-slate-500">Last updated: May 14, 2026</p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg shadow-purple-500/5 border border-purple-100 space-y-8">
            {/* Introduction */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Agreement to Terms</h2>
              <p className="text-slate-600 leading-relaxed">
                By accessing or using TeleValley's TeleValleying CRM platform ("Service"), you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you do not have permission to access the Service.
              </p>
            </section>

            {/* Account Terms */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Account Terms</h2>
              <div className="text-slate-600 leading-relaxed space-y-4">
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>You must be 18 years or older to use this Service</li>
                  <li>You are responsible for maintaining the security of your account and password</li>
                  <li>You are responsible for all activities that occur under your account</li>
                  <li>You must provide accurate and complete information when creating an account</li>
                  <li>One person or legal entity may not maintain more than one free account</li>
                </ul>
              </div>
            </section>

            {/* Acceptable Use */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Acceptable Use Policy</h2>
              <div className="text-slate-600 leading-relaxed space-y-4">
                <p>You agree NOT to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Use the Service for any unlawful purpose</li>
                  <li>Upload, store, or transmit malicious code or content</li>
                  <li>Interfere with or disrupt the Service or servers</li>
                  <li>Attempt to gain unauthorized access to any portion of the Service</li>
                  <li>Use the Service to send spam or unsolicited communications</li>
                  <li>Violate any applicable laws or regulations</li>
                  <li>Use the Service to make calls to numbers on Do Not Call registries (unless legally permitted)</li>
                </ul>
              </div>
            </section>

            {/* Subscription & Payments */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Subscription & Payments</h2>
              <div className="text-slate-600 leading-relaxed space-y-4">
                <p>Some features of the Service require a paid subscription:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Billing cycles are monthly or annually, as selected</li>
                  <li>All fees are due at the beginning of each billing cycle</li>
                  <li>No refunds are provided for partial months or unused services</li>
                  <li>Prices may be changed with 30 days notice</li>
                  <li>You may cancel your subscription at any time</li>
                </ul>
              </div>
            </section>

            {/* Data & Content */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Your Data & Content</h2>
              <p className="text-slate-600 leading-relaxed">
                You retain ownership of all data you upload to the Service. By using our Service, you grant us a limited license to process your data solely for providing the Service. We do not claim ownership of your leads, customer data, or call recordings.
              </p>
            </section>

            {/* Intellectual Property */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Intellectual Property</h2>
              <p className="text-slate-600 leading-relaxed">
                The Service and its original content, features, and functionality are owned by TeleValley and are protected by international copyright, trademark, and other intellectual property laws. Our trademarks may not be used without prior written consent.
              </p>
            </section>

            {/* Service Modifications */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Service Modifications</h2>
              <p className="text-slate-600 leading-relaxed">
                We reserve the right to modify, suspend, or discontinue any part of the Service at any time. We will provide reasonable notice of any significant changes that negatively affect your use of the Service.
              </p>
            </section>

            {/* Limitation of Liability */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Limitation of Liability</h2>
              <p className="text-slate-600 leading-relaxed">
                To the maximum extent permitted by law, TeleValley shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the Service. Our total liability shall not exceed the amount paid by you in the twelve months preceding the claim.
              </p>
            </section>

            {/* Termination */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Termination</h2>
              <p className="text-slate-600 leading-relaxed">
                We may terminate or suspend your account at any time, with or without cause, with or without notice. Upon termination, your right to use the Service will immediately cease. You may terminate your account at any time through your account settings or by contacting support.
              </p>
            </section>

            {/* Governing Law */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">10. Governing Law</h2>
              <p className="text-slate-600 leading-relaxed">
                These Terms shall be governed by and construed in accordance with the laws of the State of California, United States, without regard to its conflict of law provisions.
              </p>
            </section>

            {/* Contact */}
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-4">11. Contact Us</h2>
              <p className="text-slate-600 leading-relaxed">
                If you have any questions about these Terms, please contact us at{' '}
                <a href="tel:+917066333961" className="text-purple-600 hover:text-purple-700">
                  +91 7066333961
                </a>
              </p>
            </section>

            {/* Back Link */}
            <div className="pt-8 border-t border-purple-100">
              <Link to="/" className="text-purple-600 hover:text-purple-700 transition-colors">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;